import styled from 'styled-components';
import { COLORS, monoLabel, monoValue } from '../../lib/theme';

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 10px;
  background: ${COLORS.headerFill};
  border-bottom: 1px solid ${COLORS.hairline};
  flex: 0 0 auto;
`;

const CamId = styled.span`
  ${monoLabel}
  color: ${COLORS.accent};
  white-space: nowrap;
`;

// Wraps rather than overflows once the arrows, switch and stamp no longer
// fit on one line -- which they don't on a phone.
const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 4px 10px;
  min-width: 0;
`;

const Stamp = styled.span`
  ${monoValue}
  color: ${COLORS.label};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Carries the frame's age, so it is coloured by that age rather than pinned to
// the alert colour the reference design uses for its session timer -- pinning
// it there made a seconds-old frame read as red.
const Timer = styled.span`
  ${monoValue}
  color: ${(p) => p.$color || COLORS.alert};
  white-space: nowrap;
`;

/**
 * `controls` is an optional interactive slot ahead of the stamp. The header
 * sits outside the video box, so unlike the overlay plates it takes pointer
 * events as a matter of course.
 */
export default function PanelHeader({ camId, stamp, timer, timerColor, controls }) {
  return (
    <Bar>
      <CamId>{camId}</CamId>
      <Right>
        {controls}
        <Stamp>{stamp}</Stamp>
        {timer && <Timer $color={timerColor}>{timer}</Timer>}
      </Right>
    </Bar>
  );
}
